import AllTasks from './all_tasks';
import Common from './common';
import MyDay from './my_day';

export default {
  AllTasks,
  Common,
  MyDay,
};
